import { Grid } from '@material-ui/core';
import React from 'react';

import BaseDefinitionForm from 'Common/BaseDefinitionForm';
import TextField from 'Common/Form/TextField';

import { AccidentTypeDefinitionControllerService, AccidentTypeDefinitionDto } from '../../../../../api/client';
import { updateAdminAccidentTypes } from '../../../../../api/hs/accident/accident';

interface Props {
  open: boolean;

  /**
   * Fires when the dialog is wanted to be closed
   * @param success `true` when the allergy is created/updated
   */
  onClose(success: boolean): void;

  data: AccidentTypeDefinitionDto;
}

export default function AdminAccidentTypeEditDialog({ open, onClose, data }: Props) {
  return (
    <BaseDefinitionForm<AccidentTypeDefinitionDto>
      open={open}
      onClose={onClose}
      onSave={AccidentTypeDefinitionControllerService.saveAccidentTypeDefinition}
      onUpdate={updateAdminAccidentTypes}
      data={data}
      resourceReloadName="accidentTypes"
      createTitle="Kaza Türü Ekleme"
      updateTitle="Kaza Türü Düzenleme"
      maxDialogWidth={500}>
      <Grid item lg={12} md={12}>
        <TextField required name="label" label="Kaza Türü Giriniz" />
      </Grid>
    </BaseDefinitionForm>
  );
}
